<!--
 * @Descripttion:
 * @version:
 * @Author: huhu
 * @Date: 2023-04-19 14:30:22
 * @LastEditors: huhu
 * @LastEditTime: 2023-11-09 13:41:16
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {};
  },
  watch: {},
  created() {

  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
